import { legacyShadows } from '~/legacyTheme';
import { theme } from '~/theme';

export const useSxStyles = () => {
  return {
    popper: {
      '&.MuiTooltip-popper .MuiTooltip-tooltip': {
        color: 'inherit',
        backgroundColor: theme.palette.background.paper,
        borderRadius: 0,
        boxShadow: legacyShadows.drop1,
        padding: 0,
        margin: 0,
        marginTop: theme.spacing(1),
        fontWeight: 'normal',
      },
    },
  };
};
